const duration = [
    { name: "Day", value: "Day" },
    { name: "Month", value: "Month" },
    { name: "Year", value: "Year" },
];
const bed = [
    { name: "1", value: "1" },
    { name: "2", value: "2" },
    { name: "3", value: "3" },
    { name: "4", value: "4" },
    { name: "5+", value: "5" },
];

const bath = [
    { name: "1", value: "1" },
    { name: "2", value: "2" },
    { name: "3", value: "3" },
    { name: "4", value: "4" },
    { name: "5+", value: "5" },
];

const amenities = [
    { value: "Furnished" },
    { value: "Pet Allowed" },
    { value: "Shared Accomodation" },
];

export { duration, bed, bath, amenities }